import { useTranslation } from 'react-i18next';
import React, { useState, useContext, useEffect } from 'react';
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';
import { useLocation } from "react-router-dom";
// * CSS
import './scenario.css';
// * Helpers
import API, { AMS } from "../../services/api";
import AuthContext from '../../context/Auth/AuthContext';

const MatrixActionsBar = (props) => {

    /**We use the useTranslation hook to update the text when the language changes */
    const { t } = useTranslation('common');
    //* To can acess the parameters sent via history.push
    const location = useLocation();

    // Session context to get the current institution data
    const { user } = useContext(AuthContext);

    const [sexSelector, setSexSelector] = useState(0);
    const [groupSelector, setGroupSelector] = useState(0);

    useEffect(() => {
        //Restore selectors values when tree view change
        if (props.selectedNodeData) {
            setSexSelector(0);
            setGroupSelector(0);
        }
    }, [props.selectedNodeData]);

    const generateSelectors = () => {
        // * we use breadcumb from selectedNode and metada information, to generate selectors
        // * only suppoty combobox for sex and group
        try {
            if (props.selectedNodeData.type === 'matrix') {
                if (props.selectedNodeData.breadcrumb !== "") {
                    if (props.matrixMetadata) {
                        const selectorList = props.selectedNodeData.breadcrumb.split(',');
                        const selectorType = props.selectedNodeData.breadcrumbTypes.split(',');
                        const selectors = selectorList.map((item, i) => {
                            let result = null;
                            if (selectorType[i] === 'combobox') {
                                const dimindex = props.matrixMetadata.dimlist.indexOf(item);
                                const options = props.matrixMetadata.dimdata[dimindex].values.map((op, j) => {
                                    return <option key={j} value={j}>{op}</option>
                                });
                                result = (
                                    <select className="form-control ilo-input ilo-selectors" key={i} value={item === "s" ? sexSelector : groupSelector} onChange={(e) => { onSelectorChange(e, item) }}>
                                        {options}
                                    </select>
                                )
                            }
                            return result;
                        });
                        return selectors;
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
        return null;
    }

    const createSelectorsString = () => {
        // * this function generate the selectors string like s=0,g=0
        const selectorList = props.selectedNodeData.breadcrumb.split(',');
        const selectors = selectorList.map((item) => {
            let result = '';
            if (item === "s") {
                result =  `s=${sexSelector}`;
            } else if (item === "g") {
                result = `g=${groupSelector}`;
            }
            return result;
        });
        return selectors.join('');
    }

    const onSelectorChange = (event, dim) => {
        if (dim === "s") {
            setSexSelector(event.target.value);
        } else if (dim === "g") {
            setGroupSelector(event.target.value);
        }
    }

    useEffect(() => {
        // * this useEffect handle the change from the selectors and get update the matrix using the new selectors
        if (props.selectedNodeData.type === 'matrix') {
            const selectorList = props.selectedNodeData.breadcrumb.split(',');
            const selectors = selectorList.map((item) => {
                let result = '';
                if (item === "s") {
                    result = `s=${sexSelector}`;
                } else if (item === "g") {
                    result = `g=${groupSelector}`;
                }
                return result;
            });
            props.getMatrixData(props.selectedNodeData.code, selectors.join(','));
        }
    }, [sexSelector, groupSelector]);// eslint-disable-line react-hooks/exhaustive-deps

    const handleCheckout = async () => {
        try {
            const isLockRes = await API.get(`/Scenario/IsLock?scenarioId=${location.state.detail.scenarioId}&userCode=${user.email}`);
            const isCehckoutRes = await API.get(`/Scenario/IsCheckout?scenarioId=${location.state.detail.scenarioId}&userCode=${user.email}`);

            if (isLockRes.data.code !== 100) {
                Notifications.notify(isLockRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            if (isCehckoutRes.data.code !== 100) {
                Notifications.notify(isCehckoutRes.data.msg, ERROR_NOTIFICATION);
                return;
            }

            const isLockData = isLockRes.data.data;
            const isCheckoutData = isCehckoutRes.data.data;

            // * If model is not lock by other user
            if (!isLockData.isLock && !isCheckoutData) {
                // * generate selector string like s=0,g=0
                const selectors = createSelectorsString();


                // * call api to do checkout
                const checkoutRes = await AMS.get(`/checkout/SCENARIO/${location.state.detail.scenarioId}/${props.selectedNodeData.code}/${selectors}`, {
                    params: {
                        usr: user.email
                    }
                });

                if (checkoutRes.data.result === -1) {
                    Notifications.notify(checkoutRes.data.message, ERROR_NOTIFICATION);
                    return;
                }


                // * get checkout data to update matrixData
                const checkoutInfoRes = await AMS.get(`/getcheckoutinfo/SCENARIO/${location.state.detail.scenarioId}/${props.selectedNodeData.code}/${selectors}`);

                if (checkoutInfoRes.data.result === -1) {
                    Notifications.notify(checkoutInfoRes.data.message, ERROR_NOTIFICATION);
                    return;
                }

                props.setMatrixData({ ...props.matrixData, ...checkoutInfoRes.data });

                // * enable spread
                props.validate_edit(props.matrixData.datablockranges, true);

            } else {
                // **** If not, error is displayed
                if (isLockData.isLock) {
                    Notifications.notify(t('scenarios.add_benefit.edit_by', { user: isLockData.editLockUserCode }), ERROR_NOTIFICATION);
                    return;
                } else if (isCheckoutData) {
                    Notifications.notify(t('scenarios.add_benefit.ischeckout'), ERROR_NOTIFICATION);
                    return;
                }
            }
        } catch (error) {
            console.log(error);
            Notifications.notify(String(error), ERROR_NOTIFICATION);
        }
    }

    const handleUndoCheckout = async () => {
        // * generate selector string like s=0,g=0
        const selectors = createSelectorsString();

        // * call api to do undocheckout
        const checkoutRes = await AMS.get(`/undo/SCENARIO/${location.state.detail.scenarioId}/${props.selectedNodeData.code}/${selectors}`, {
            params: {
                usr: user.email
            }
        });
        if (checkoutRes.data.result === -1) {
            Notifications.notify(checkoutRes.data.message, ERROR_NOTIFICATION);
            return;
        }

        // * get checkout data to update matrixData
        const checkoutInfoRes = await AMS.get(`/getcheckoutinfo/SCENARIO/${location.state.detail.scenarioId}/${props.selectedNodeData.code}/${selectors}`);
        if (checkoutInfoRes.data.result === -1) {
            Notifications.notify(checkoutInfoRes.data.message, ERROR_NOTIFICATION);
            return;
        }

        props.getMatrixData(props.selectedNodeData.code, selectors);
    }

    const handleSave = () => {
        // * generate selector string like s=0,g=0
        const selectors = createSelectorsString();
        props.saveMatrixData(selectors);
    }

    const handleCheckin = () => {
        // * generate selector string like s=0,g=0
        const selectors = createSelectorsString();

        props.checkinMatrixData(selectors)
    }

    const handleExport = () => {
        props.exportData();
    }

    const handleClean = () => {
        props.cleanMatrixData()
    }
    return (
        props.selectedNodeData !== null ?
            <div className="container-fluid">

                <div className="row mt-2">
                    <div className="col-12">
                        {props.selectedNodeData.type === 'matrix' ?
                            /**
                             * for matrix 
                             */
                            <p>{props.matrixData?.ischeckedout ? `(${t('scenarios.checkout_by', {username: props.matrixData.checkoutuser} )})  ` : ''}{props.selectedNodeData.text}</p>
                            /**
                             * for report
                             */
                            : <p>{props.selectedNodeData.text}</p>
                        }
                    </div>
                </div>

                {props.selectedNodeData.type === 'matrix' ?

                    /**
                     * for matrix 
                     */
                    (props.matrixData ? (
                        <>
                            <div className="row mx-0">
                                <button className="btn btn-primary ilo-btn mr-2" onClick={handleExport}>{t('scenarios.export_btn')}</button>
                                {!props.selectedNodeData.readonly ?

                                    props.matrixData.ischeckedout && user.email === props.matrixData.checkoutuser ? (
                                        <>
                                            <button className="btn btn-primary ilo-btn mr-2" onClick={handleClean}>{t('scenarios.clean_btn')}</button>
                                            <button className="btn btn-primary ilo-btn mr-2" onClick={handleSave}>{t('scenarios.save_btn')}</button>
                                            <button className="btn btn-primary ilo-btn mr-2" onClick={handleCheckin}>{t('scenarios.checkin_btn')}</button>
                                            <button className="btn btn-primary ilo-btn mr-2" onClick={handleUndoCheckout}>{t('scenarios.undo_btn')}</button>
                                        </>
                                    ) : <button className="btn btn-primary ilo-btn mr-2" onClick={handleCheckout}>{t('scenarios.checkout_btn')}</button>
                                        


                                    : null}
                            </div>
                            <div className="row mx-0 my-3">
                                {generateSelectors()}
                            </div>
                        </>) : null) :
                    /**
                     * for report
                     */
                    (
                        <div className="row mx-0">
                            <button className="btn btn-primary ilo-btn mr-2" onClick={handleExport}>Export</button>
                        </div>
                    )
                }
            </div> : null

    );
}

export default MatrixActionsBar